import { render } from "./ProductOptionEdit.vue?vue&type=template&id=82ad8388"
import script from "./ProductOptionEdit.vue?vue&type=script&lang=js"
export * from "./ProductOptionEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__